module.exports = __webpack_public_path__ + "static/media/360-poster.8c249080.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/360-poster.jpg
// module id = 413
// module chunks = 0